import { Button } from "../../ui/button";
import { ArrowUpDown, MoreHorizontal } from "lucide-react";
import { format } from "date-fns";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { Link } from "react-router-dom";
import { Badge } from "../../ui/badge";
export const columns = ({ onSort, onConfirm }) => [

  {
    accessorKey: "title",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="px-0 py-0"
          onClick={() => onSort("Title")}
        >
          Tiêu đề
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const title = row.getValue("title");
      return <div className="w-52  line-clamp-3 ">{title}</div>;
    },
  },
  {
    accessorKey: "isActive",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="px-0 py-0"
          onClick={() => onSort("IsActive")}
        >
          Trạng thái
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const isApproved = row.original?.createPostRequest?.isApproved;
      const isLocked = row.original?.createPostRequest?.isLocked;
      const isPending = row.original?.createPostRequest?.isPending;
      const isRejected = row.original?.createPostRequest?.isRejected;
      let statusBadge;
      if (isApproved === true) {
        statusBadge = <Badge variant="success">Đã duyệt</Badge>;
      } else if (isLocked === true) {
        statusBadge = <Badge variant="warning">Bị khóa</Badge>;
      } else if (isRejected === true) {
        statusBadge = <Badge variant="destructive">Đã từ chối</Badge>;
      }  else if (isPending === true) {
        statusBadge = <Badge variant="info">Đang chờ</Badge>;
      }
      return (
        <div>{statusBadge}</div>
      );
    },
  },

  // {
  //   accessorKey: "organizeName",
  //   header: ({ column }) => {
  //     return (
  //       <Button
  //         variant="ghost"
  //         className="px-0 py-0"
  //          onClick={() => onSort("Title")}
  //       >
  //         Tổ chức
  //         <ArrowUpDown className="ml-2 h-4 w-4" />
  //       </Button>
  //     );
  //   },
  //   cell: ({ row }) => {
  //     const organizeName = row.getValue("organizeName");
  //     return (
  //       <div>
  //         {organizeName ? (
  //           <span className="bg-orange-100 text-orange-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-orange-900 dark:text-orange-300">
  //             {organizeName}
  //           </span>
  //         ) : (
  //           <span className="bg-orange-100 text-orange-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-orange-900 dark:text-orange-300">
  //             {organizeName}
  //           </span>
  //         )}
  //       </div>
  //     );
  //   },
  // },

  {
    accessorKey: "createAt",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="px-0 py-0"
          onClick={() => onSort("CreateAt")}
        >
          Thời gian tạo
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const dateCreate = format(new Date(row.getValue("createAt")), 'dd/MM/yyyy, h:mm:ss a');
      return <div className="w-max">{dateCreate}</div>;
    },
  },

  //   Thêm Actions vào columns
  {
    id: "actions",
    cell: ({ row }) => {
      const infoRow = row.original;//Khai báo row ban đầu

      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Hành Động</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() =>
                navigator.clipboard.writeText(infoRow.newTitle)//Copy tên row tên news
              }
            >
              Copy tiêu đề
            </DropdownMenuItem>

            {infoRow?.isActive === true ? (
              <div>
                <DropdownMenuSeparator />
                <DropdownMenuItem

                >
                  <Link
                    to={`/news/newsDetail/${row.original?.postID}`}>Xem tin tức</Link>
                </DropdownMenuItem>
              </div>
            ) : ""}
            {infoRow?.createPostRequest?.isPending === true ? (
              <div>
                <DropdownMenuSeparator />
                <DropdownMenuItem

                >
                  <Link to={`/updateNews/${row.original?.createPostRequest?.createPostRequestID}`}>
                    Chỉnh sửa tin tức
                  </Link>
                </DropdownMenuItem>
              </div>
            ) : ""}
            {infoRow?.createPostRequest?.isRejected === true ? (
              <div>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={() =>
                    onConfirm(row.original)
                  }
                >
                  Ẩn
                </DropdownMenuItem>
              </div>
            ) : ""}

          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];
